
class CustomProduct extends HTMLElement {
  constructor() {
    super();

    // 选择器
    const selectors = {
      mediaImage: '.drawer_recommend__image',
      form: '.drawer-rec__form-wrapper>form',
      variantSelect: '.recomd-product__select',
      variantsJson: '.pr_variants_json',
      optionsJson: '.pr_options_json',
      priceWrapper: '.recomd-product__price-group',
      nowPrice: '.recomd-product__price',
      comparePrice: '.recomd-product__compare_price',
      swatch: '.drawer-rec-inner',
      swatchOption: ' .recomd-swatch__option',
      swatchOptionLabel: '.recomd-swatch__title .recomd-swatch__current',
      swatchOptionItem: '.recomd-swatch__list .recomd-swatch__item',
      qtyMinus: '.quantity-selector.is--minus',
      qtyPlus: '.quantity-selector.is--plus',
      qtyInput: '.quantity-input',
      buybutton: '.drawer-rec__form-btn-submit'
    };
    // 标记
    const marks = {
      selectedClass: 'is--selected',
      optionDisabledClass: 'is--disabled', // 选项禁止选择
      soldStatus: { // 产品可售状态
        available: 'available',
        soldOut: 'sold-out', // 售罄
      },
      activeClass: 'active',
    };
    // 元素

    const elements = {
      mediaImage: this.querySelector(selectors.mediaImage),
      buyButton: this.querySelector(selectors.buybutton),
      form: this.querySelector(selectors.form),
      variantSelect: this.querySelector(selectors.variantSelect),
      variantsJson: this.querySelector(selectors.variantsJson),
      optionsJson: this.querySelector(selectors.optionsJson),
      priceWrapper: this.querySelector(selectors.priceWrapper),
      nowPrice: this.querySelector(selectors.nowPrice),
      comparePrice: this.querySelector(selectors.comparePrice),
      swatch: this.querySelector(selectors.swatch),
      swatchOptionList: this.querySelectorAll(selectors.swatchOption),
      swatchOptionItemList: this.querySelectorAll(selectors.swatchOptionItem),
      qtyMinus: this.querySelector(selectors.qtyMinus),
      qtyPlus: this.querySelector(selectors.qtyPlus),
      qtyInput: this.querySelector(selectors.qtyInput),
    };

    const variantsJson = JSON.parse(elements.variantsJson.innerHTML);
    const optionsJson = JSON.parse(elements.optionsJson.innerHTML);

    // 代理源
    const _refOrigin = {
      variant: null, // 产品变体
    };
    // 代理，数据驱动型
    const proxyHander = {
      get(target, key) {
        return target[key];
      },
      set(target, property, value) {
        target[property] = value;
        handleRefChanged(_refOrigin);
        return true;
      },
    };
    const ref = new Proxy(_refOrigin, proxyHander);

    const selectOptons = []; // 已选择的配置
    //   初始化已选择的配置 
    for (let option of optionsJson) {
      selectOptons[option.position - 1] = option.values[0];
    }
    //  初始化代理 
    // ref.variant = variantsJson[0];
    ref.variant = variantsJson.find((v, i) => v.available == true);
    //   代理发生变化 
    function handleRefChanged(refOrigin) {
      // 更新变体选择器的值 
      elements.variantSelect.value = refOrigin.variant.id;
      //  更新已选 Option 项存储数据 
      selectOptons.length = 0;
      selectOptons.push(...refOrigin.variant.options);
      //  更新选 Option 标题视图 
      for (let optionEl of elements.swatchOptionList) {
        const optionPosition = optionEl.getAttribute('data-option-position');
        const labelEl = optionEl.querySelector(selectors.swatchOptionLabel);
        labelEl.innerHTML = selectOptons[optionPosition - 1];
      }
      //  更新选 Option 项视图 
      for (let optionItemEl of elements.swatchOptionItemList) {
        const optionPosition = optionItemEl.getAttribute('data-option-position');
        const value = optionItemEl.getAttribute('data-value');
        const nowIsActived = optionItemEl.classList.contains(marks.selectedClass);
        const needIsActived = value == selectOptons[optionPosition - 1];
        if (nowIsActived != needIsActived) {
          //  选择项与代理不相同时，才会更新视图 
          if (nowIsActived) optionItemEl.classList.remove(marks.selectedClass);
          else optionItemEl.classList.add(marks.selectedClass);
        }
        //   有时，该选项不能与其他已选项搭配在一起，因为可能没有这样子的变体 
        const tempOptions = [...selectOptons];
        tempOptions[optionPosition - 1] = value;
        const isExist = variantsJson.findIndex((v) => v.available.toString() == 'true' && v.options.toString() == tempOptions.toString()) > -1;
        const isDisabled = optionItemEl.classList.contains(marks.optionDisabledClass);
        if (isExist == isDisabled) {
          isExist ? optionItemEl.classList.remove(marks.optionDisabledClass) : optionItemEl.classList.add(marks.optionDisabledClass);
        }
      }
      // 更新图片
      if (ref.variant.featured_image) elements.mediaImage.querySelector("img").setAttribute("src", ref.variant.featured_image.src);
      // 更新价格 
      const comparePrice = ref.variant.compare_at_price; // 可能为 null、0
      const price = ref.variant.price;
      elements.comparePrice.innerHTML = comparePrice && comparePrice > 0 ? `${'$'}${(comparePrice / 100).toFixed(2)}` : '';
      elements.nowPrice.innerHTML = `${'$'}${(price / 100).toFixed(2)}`;
      elements.priceWrapper.setAttribute('data-discounted', comparePrice > price);
      // 更新可售状态 
      elements.form.setAttribute("data-sold-status", refOrigin.variant.available ? marks.soldStatus.available : marks.soldStatus.soldOut);
      // 更新购买按钮的id属性 
      elements.buyButton.setAttribute("data-variant-id", elements.variantSelect.value);
    }

    elements.variantSelect.addEventListener('change', (e) => {
      const variantId = elements.variantSelect.value;
      const selectedVariant = variantsJson.find((v, i, obj) => v.id == variantId);
      ref.variant = selectedVariant;
    });

    elements.qtyMinus.addEventListener('click', (e) => {
      if (elements.qtyInput.value > 1) elements.qtyInput.value--;
    });

    elements.qtyPlus.addEventListener('click', (e) => {
      if (elements.qtyInput.value < (ref.variant.quantity_rule.max ?? Infinity)) elements.qtyInput.value++;
    });

    elements.swatchOptionList.forEach(swatchitem => {
      swatchitem.addEventListener('click', (e) => {
        // 点击了选择项
        const currentEl = e.target;
        const isActived = currentEl.classList.contains(marks.selectedClass);
        if (isActived) return;
        currentEl.classList.remove(marks.selectedClass);
        const optionPosition = currentEl.getAttribute('data-option-position');
        const optionValue = currentEl.getAttribute('data-value');
        selectOptons[optionPosition - 1] = optionValue;
        // 根据所有已选项，找出对应的变体
        const find = variantsJson.find((v, i) => v.options.toString() == selectOptons.toString());
        if (find) ref.variant = find;

      });
    });

    elements.swatchOptionItemList.forEach(swatchitem => {
      if (swatchitem.getAttribute('data-option-name') != 'Color') {
        let itme_width = swatchitem.offsetWidth
        let itme_height = swatchitem.offsetHeight
        // 计算对角线的偏移角度
        let angleRadians = Math.atan(itme_height / itme_width); // 弧度
        let angleDegrees = angleRadians * (180 / Math.PI); // 转换为度
        swatchitem.style.setProperty('--line-width', Math.sqrt(itme_width * itme_width + itme_height * itme_height) + 'px');
        swatchitem.style.setProperty('--line-transform', `rotate(${angleDegrees}deg)`);
      }
    })

  }

}

customElements.define('custom-product', CustomProduct);